import type { Notice } from '../api/client';
import type { T } from '../i18n';

type Item = Notice['sections'][number]['items'][number];

/**
 * Notice sentences as generated by the server (SPEC §8.2). A claim is a protection proven by an
 * automated test, and says so; a disclosure is what can happen to the data, and is shown plainly.
 */
export function NoticeItems({ items, t }: { items: Item[]; t: T }) {
  return (
    <ul class="notice-items">
      {items.map((item, i) => (
        <li key={i} class={'claim' in item ? 'is-claim' : 'is-disclosure'}>
          {'claim' in item && (
            <>
              <svg class="notice-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M5 12l5 5L20 7" />
              </svg>
              <span class="visually-hidden">{t('claimTested')} </span>
            </>
          )}
          {item.text}
        </li>
      ))}
    </ul>
  );
}
